export const recent16 = "M1 2v2.582A7.795 7.795 0 1 1 .272 9h1.01a6.802 6.802 0 1 0 .625-4H4v1H0V2zm10 7H8V5H7v5h4z";
